(() => {
  const M = window.Marelou || {};
  const config = M.anniversary;
  if (!config) return;
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const eligible = new Set(config.productIds);
  const active = () => config.enabled && Date.now() >= start && Date.now() < end;
  const qualifies = (id) => active() && eligible.has(String(id));
  const money = (cents) => new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR',minimumFractionDigits:cents % 100 === 0 ? 0 : 2}).format(cents / 100);
  const amount = (price, id) => qualifies(id) ? Math.round(price * .8) : price;
  const renderPrice = (el, price, compare = 0) => {
    el.dataset.annivBase = price;
    el.dataset.annivCompare = compare || 0;
    const discounted = qualifies(el.dataset.annivProduct);
    const prefix = el.dataset.annivFrom === 'true' ? `<small>${config.labels.from} </small>` : '';
    el.classList.toggle('price--anniv', discounted);
    el.classList.toggle('price--sale', !discounted && compare > price);
    el.innerHTML = discounted
      ? `${prefix}${money(amount(price, el.dataset.annivProduct))}<s>${money(price)}</s><span class="price__anniv-label">−20 %</span><small class="price__anniv-note">${config.labels.priceNote}</small>`
      : `${prefix}${money(price)}${compare > price ? `<s>${money(compare)}</s>` : ''}`;
  };
  const renderAmount = (el, price, id) => {
    el.dataset.annivBase = price;
    if (id) el.dataset.annivProduct = id;
    el.textContent = money(amount(price, el.dataset.annivProduct));
  };
  const refresh = () => {
    const running = active();
    document.querySelectorAll('[data-anniv-live]').forEach(el => {el.hidden = !running || Boolean(el.dataset.annivProduct && !qualifies(el.dataset.annivProduct));});
    document.querySelectorAll('[data-anniv-rest]').forEach(el => {el.hidden = running;});
    document.querySelectorAll('[data-anniv-price]').forEach(el => renderPrice(el, Number(el.dataset.annivBase), Number(el.dataset.annivCompare)));
    document.querySelectorAll('[data-anniv-amount]').forEach(el => renderAmount(el, Number(el.dataset.annivBase)));
    document.querySelectorAll('[data-anniv-date]').forEach(el => {el.textContent = new Intl.DateTimeFormat('fr-FR',{day:'numeric',month:'long',hour:'2-digit',minute:'2-digit',timeZone:'Europe/Paris'}).format(new Date(end));});
  };
  let previousState;
  const tick = () => {
    const running = active();
    if (running !== previousState) {previousState = running; refresh();}
    const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    const values = {days:Math.floor(seconds / 86400),hours:Math.floor(seconds / 3600) % 24,minutes:Math.floor(seconds / 60) % 60,seconds:seconds % 60};
    document.querySelectorAll('[data-anniv-timer]').forEach(timer => {
      for (const [unit,value] of Object.entries(values)) {
        const node = timer.querySelector(`[data-anniv-${unit}]`);
        const text = String(value).padStart(2,'0');
        if (node && node.textContent !== text) node.textContent = text;
      }
    });
  };
  Object.assign(config,{isActive:active,qualifies,amount,renderPrice,renderAmount,refresh});
  const dialog = document.querySelector('[data-anniv-dialog]');
  let opener;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-anniv-open]');
    if (button && dialog) {opener = button; refresh(); dialog.showModal();}
    if (event.target.closest('[data-anniv-close]') && dialog) dialog.close();
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  if (dialog) dialog.addEventListener('close', () => {if (opener && opener.isConnected) opener.focus({preventScroll:true});});
  document.addEventListener('shopify:section:load', () => {refresh(); tick();});
  document.addEventListener('visibilitychange', () => {if (!document.hidden) tick();});
  tick();
  window.setInterval(() => {if (!document.hidden) tick();},1000);
})();
